/** 웰스토리몰 */
export const SITE_WELMALL = '1000000001';
/** 대한항공 */
export const SITE_SKYPASS = 'N2507000011';
/** 한미글로벌 */
export const SITE_HANMI = 'N2508000016';
/* TYM */
export const SITE_TYM = 'N2603000024';
/* Kolon */
export const SITE_KOLON = 'N2603000025';
/* 아시아나 */
export const SITE_ASIANA = 'N2602000023';
